export const decode = (inputString: string) => {
  try {
    const base64 = window.atob(window.atob(window.atob(inputString)))
    const decodedBase64 = window.atob(base64)
    const binaryString = decodedBase64
    const bytes = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    return new TextDecoder().decode(bytes)
  } catch (error) {
    console.error('Decoding error:', error)
    return window.atob(window.atob(window.atob(window.atob(inputString))))
  }
}
